import { Button, SkeletonStack } from '@/shared/ui'
import styles from '../AdminPages.module.css'

interface AdminRemoteStateProps {
  kind: 'loading' | 'error' | 'empty'
  title?: string
  message?: string
  onRetry?: () => void
}

export function AdminRemoteState({ kind, title, message, onRetry }: AdminRemoteStateProps) {
  if (kind === 'loading') {
    return (
      <div className={styles.panel} aria-label="Загрузка">
        <SkeletonStack rows={5} height={42} />
      </div>
    )
  }

  return (
    <div className={styles.state} role={kind === 'error' ? 'alert' : 'status'}>
      <p className={styles.stateTitle}>
        {title ?? (kind === 'error' ? 'Не удалось загрузить данные' : 'Здесь пока пусто')}
      </p>
      {message && <p className={styles.stateText}>{message}</p>}
      {kind === 'error' && onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Повторить
        </Button>
      )}
    </div>
  )
}

interface AdminPaginationProps {
  total: number
  offset: number
  limit: number
  onChange: (offset: number) => void
  disabled?: boolean
}

export function AdminPagination({
  total,
  offset,
  limit,
  onChange,
  disabled,
}: AdminPaginationProps) {
  if (total <= limit && offset === 0) return null

  const from = total === 0 ? 0 : offset + 1
  const to = Math.min(offset + limit, total)

  return (
    <div className={styles.pagination}>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => onChange(Math.max(0, offset - limit))}
        disabled={disabled || offset === 0}
      >
        Назад
      </Button>
      <span className={styles.pageInfo}>
        {from}–{to} из {total}
      </span>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => onChange(offset + limit)}
        disabled={disabled || offset + limit >= total}
      >
        Дальше
      </Button>
    </div>
  )
}
